import { historyGraphPalette } from '../Tabs/Graph/graph_config';

// Installation identity fixes the colour independently of names, sort order or
// legend visibility. The 13 history colours plus lighter variants cover 24 slots.
export function getLightProfileColour(profileKey) {
  const parts = String(profileKey ?? '').split(':');
  const channel = Number(parts[parts.length - 1]);
  const subzone = Number(parts[parts.length - 2]);
  const slot =
    Number.isInteger(channel) &&
    channel >= 0 &&
    channel < 6 &&
    Number.isInteger(subzone) &&
    subzone >= 0 &&
    subzone < 4
      ? subzone * 6 + channel
      : 0;
  const colour = historyGraphPalette[slot % historyGraphPalette.length];
  if (slot < historyGraphPalette.length) return colour;
  const rgb = colour.match(/\d+/g).map(Number);
  return `rgb(${rgb.map((value) => Math.round(value + (255 - value) * 0.35)).join(', ')})`;
}
